// Původní název:		sk.widgets.Pager
// Původní umístění:	shared/js/widget/sk.widgets.Pager.js
// Status:				Používáno
// Funkcionalita:		Stránkování pro carousely - tečky
//						Používá se jen v carousel.js

// Poznámky:			Widget Pager
//						version 1
//						Created: 14.02.2012 | Michal Matuška(michal.matuska@superkoderi.cz)

// TODO pokud se bude měnit plugin pro carousely, toto se může odstranit
// #CHECKED jthiemel 190108


import $ from 'jquery';


class Pager {
	constructor(options) {
		this.options = $.extend({
			// aktivní
			current: 0,
			// počet stránek
			max: 0,
			// krok
			step: 1,
			// nekonečné
			infinite: false,
			// ovládací prvek pro předchozí
			pagerPrev: null,
			// ovládací prvek pro další
			pagerNext: null,
			// vygenerovat menu pro kroky
			pagerPages: null,
			// maska kroků
			pagerMask: null,
			pagerMaskString: '{$active}/{$all}', // {$active} = aktivní položka, {$all} = celkový počet

			// callbacky
			onChange: null,

		}, options);

		this.current = this.options.current;
		this.step = this.options.step;
		this.min = 0;
		this.max = this.options.max;
		this.infinite = this.options.infinite;
		this.isInit = false;

		return this;
	}

	init() {
		/*if(!this.max)
		{
			return this;
		}*/

		var o = this.options;

		// předchozí
		if (o.pagerPrev) {
			this.$pagerPrev = o.pagerPrev.jquery ? o.pagerPrev : $(o.pagerPrev);

			this.$pagerPrev
				.on('click', $.proxy(this.handlePrev, this));

			this.prevDisabled = false;
		}

		// další
		if (o.pagerNext) {
			this.$pagerNext = o.pagerNext.jquery ? o.pagerNext : $(o.pagerNext);

			this.$pagerNext
				.on('click', $.proxy(this.handleNext, this));

			this.nextDisabled = false;
		}

		// stránky
		if (o.pagerPages) {
			this.$pagerPages = o.pagerPages.jquery ? o.pagerPages : $(o.pagerPages);



			var pages = '';
			for (var i = 0; i <= this.max; i++) {
				pages += '<a href="#" data-sk-page-index="' + i + '">' + (i + 1) + '</a>';
			}

			this.$pagerPages
				.append(pages)
				.delegate('a', 'mousedown touchstart', $.proxy(this.handlePage, this))
				.delegate('a', 'click', $.proxy(this.handlePrevent, this));
		}

		// mask
		if (o.pagerMask) {
			this.$pagerMask = o.pagerMask.jquery ? o.pagerMask : $(o.pagerMask);
		}

		this.isInit = true;

		this.check();

		return this;
	}

	reinit() {
		this.check();
	}

	destroy() {
		var o = this.options;

		// odstraní
		if (typeof this.$pagerPrev != 'undefined') {
			this.$pagerPrev
				.unbind('mousedown touchstart', this.handlePrev)
				.unbind('click', this.handlePrevent);

			delete this.$pagerPrev;
			delete this.prevDisabled;
		}

		// další
		if (typeof this.$pagerNext != 'undefined') {
			this.$pagerNext
				.unbind('mousedown touchstart', this.handleNext)
				.unbind('click', this.handlePrevent);

			delete this.$pagerNext;
			delete this.nextDisabled;
		}

		// stránky
		if (typeof this.$pagerPages != 'undefined') {
			this.$pagerPages
				.undelegate('a', 'mousedown touchstart', this.handlePage)
				.undelegate('a', 'click', this.handlePrevent)
				.empty();

			delete this.$pagerPages;
		}

		// mask
		if (typeof this.$pagerMask != 'undefined') {
			this.$pagerMask.empty();
			delete this.$pagerMask;
		}

		this.isInit = false;

		return this;
	}

	prev() {
		if (this.min != this.current || this.infinite) {
			var i = this.current - this.step;

			if (this.infinite) {
				this.current = (i + (this.max + 1)) % (this.max + 1);
			}
			else {
				this.current = (i < this.min) ? this.min : (i > this.max) ? this.max : i;
			}

			this.check();

			typeof this.options.onChange == 'function' && this.options.onChange({ current: this.current, prev: true, next: false, page: false });
		}
	}

	next() {
		if (this.max != this.current || this.infinite) {
			var i = this.current + this.step;

			if (this.infinite) {
				this.current = i % (this.max + 1);
			}
			else {
				this.current = (i < this.min) ? this.min : (i > this.max) ? this.max : i;
			}

			this.check();

			typeof this.options.onChange == 'function' && this.options.onChange({ current: this.current, prev: false, next: true, page: false });
		}
	}

	page(i, noCall) {
		if (this.current !== i) {
			var i = (i < this.min) ? this.min : (i > this.max) ? this.max : i;

			this.current = i;
			this.check();

			!noCall && typeof this.options.onChange == 'function' && this.options.onChange({ current: this.current, prev: false, next: false, page: true });
		}
	}

	check () {
		this.checkPrev();
		this.checkNext();
		this.checkPage();
		this.checkPagesMask();
	}

	// události

	handlePrev(e) {
		this.prev();
		e.preventDefault();
	}

	handleNext(e) {
		this.next();
		e.preventDefault();
	}

	handlePage(e) {
		this.page($(e.target).data('sk-page-index'));
		e.preventDefault();
	}

	handlePrevent(e) {
		e.preventDefault();
	}

	// kontroly

	checkPrev(e) {
		if (typeof this.$pagerPrev != 'undefined') {
			if (this.min >= this.current && !this.infinite) {
				this.$pagerPrev.addClass('disabled');
				this.prevDisabled = true;
			}
			else if (this.prevDisabled) {
				this.$pagerPrev.removeClass('disabled');
				this.prevDisabled = false;
			}
		}
	}

	checkNext(e) {
		if (typeof this.$pagerNext != 'undefined') {
			if (this.max <= this.current && !this.infinite) {
				this.$pagerNext.addClass('disabled');
				this.nextDisabled = true;
			}
			else if (this.nextDisabled) {
				this.$pagerNext.removeClass('disabled');
				this.nextDisabled = false;
			}
		}
	}

	checkPage() {
		if (typeof this.$pagerPages != 'undefined') {
			this.$pagerPages
				.find('a')
				.removeClass('active')
				.eq(this.current)
				.addClass('active');
		}
	}

	checkPagesMask() {
		if (typeof this.$pagerMask != 'undefined') {
			this.$pagerMask
				.text(this.options.pagerMaskString.replace('{$active}', this.current + 1).replace('{$all}', this.length));
		}
	}
}

export default Pager;
